<script setup lang="ts">
import { theme } from '@/config/brands'

const background = theme.bgGlobal || '#14181F'
</script>

<template>
  <div class="rr-centered-loading" :style="{ background }">
    <BasicSpinner class="mx-auto" />
  </div>
</template>

<style scoped>
.rr-centered-loading {
  position: fixed;
  inset: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
